import React, { useRef, useState, useEffect } from 'react';
import { useAuthDataContext } from './../__providers/AuthProvider';
import { useAppDataContext } from './../__providers/AppProvider'
import { HashLink as Link, Redirect } from 'react-router-hash-link';
import { useHistory } from 'react-router-dom'
import Api from './../__helpers/api';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Button from '@material-ui/core/Button';
import '../assets/css/header.css';
import Success from './modals/Success';
import Info from './modals/Info';
import FacebookLogin from 'react-facebook-login';
import Loading from 'react-loading-bar'
import 'react-loading-bar/dist/index.css'
import { ClickAwayListener } from '@material-ui/core';
import Activate from './modals/profile/Activate';
import { useLocation } from 'react-router-dom';

//images
import brandBlack from '../assets/images/header/brand.png';
import brandWhite from '../assets/images/header/brand-white.png';
import fb from '../assets/images/header/fb.png';
import profile from '../assets/images/header/profile-icon.png';
import keysIcon from '../assets/images/header/keys-icon.png';
import passwordIcon from '../assets/images/home/password-icon.png';
import profileIcon from '../assets/images/home/profile-icon.png';
import closeButton from '../assets/images/header/close.png';
import loader from '../assets/images/contacts/loader.svg';
import brandNoR from '../assets/images/header/brand-no-r.png';
import checkIcon from '../assets/images/profile/activation-check.png'
import attentionIcon from '../assets/images/profile/attention-icon.png'
import logoutIcon from '../assets/images/header/logout.png'
import fbFilledIcon from '../assets/images/header/fb-filled.png'
import loaderWhite from '../assets/images/interactive-road-signals/loader.svg'

//partials
import Notifications from './STRUCTURE_MIGRATION/app/Notifications'

function Header(props) {
    const app = useAppDataContext()

    const history = useHistory()
    const brand = props.headerBlackFonts ? brandBlack : brandWhite;

    const params = new URLSearchParams(window.location.search)

    const overlayRef = useRef(null);
    const loginWindowRef = useRef(null);

    const auth = useAuthDataContext();
    const laoderGif = useRef(null);
    const submitButton = useRef(null);

    const location = useLocation();

    //validation states
    const [validation, setValidation] = useState(false);

    const [form, setForm] = useState({
        successModal: false,
        successOverlay: false,
        toggle: true,
        forgottenPassword: '',
        menu: false,
        errorModal: false,
        errorOverlay: false,
        fbLoading: false,
        sendOnEmail: true
    });

    const [main, setMain] = useState({
        activateOverlay: false,
        activateModal: false,
        methodModal: true,
        showCodeModal: false,
        errorOverlay: false,
        errorModal: false
    })

    useEffect(() => {
        if (form.menu) {
            toggleMenuClick();
            handleClickAway()
        }

        if (params.get('sa') == 1) {
            if (auth.isLogged && !auth.user.activated) handleActivate()
            else showLogin()

            const userId = params.get('u')

            if (userId) {
                Api.post('increase-email-activation-count', {
                    u: userId
                })
            }
        }
    }, [location]);

    const handleFpwField = e => {
        let val = e.target.value;
        setForm(form => {
            return {
                ...form,
                forgottenPassword: val,
            }
        })

    }
    const login = e => {
        laoderGif.current.style.display = 'block';
        submitButton.current.style.display = 'none';
        e.preventDefault();

        setValidation(false);

        let loginUrl = 'login';
        let data = new FormData(e.target);

        const invitationLink = window.localStorage.getItem('r');

        if (invitationLink) {
            data.append('link', invitationLink);
        }

        Api.post(loginUrl, data)
            .then(res => {

                laoderGif.current.style.display = 'none';
                submitButton.current.style.display = 'block';

                if (res.status === 200 && res.data.success) {

                    window.localStorage.removeItem('r');

                    auth.login(res.data.data.user);

                    if (!res.data.data.user.is_student && res.data.data.user.confirmed == 0) {
                        setForm(form => {
                            return {
                                ...form,
                                errorOverlay: true,
                            }
                        })
                        setTimeout(() => {
                            setForm(form => {
                                return {
                                    ...form,
                                    errorModal: true,
                                }
                            })
                        }, 50);
                        return;
                    }

                    closeLogin();

                    // window.location.reload();
                    if (location.search == '?show_activation') {
                        window.location.href = '/?show_activation';
                    } else {
                        window.location.href = '/';
                    }

                    // props.history.push('/');

                    // setTimeout(() => {
                    //     overlayRef.current.style.display = 'none';
                    // }, 100);

                    // loginWindowRef.current.style.opacity = '0';
                    // loginWindowRef.current.style.top = '20px';

                } else setValidation(true);
            })
            .catch(error => {
                laoderGif.current.style.display = 'none';
                submitButton.current.style.display = 'block';
                setValidation(true);
            });
    }

    const closeLogin = () => {
        props.closeLogin(false)
        setTimeout(() => {
            overlayRef.current.style.display = 'none'
        }, 100);
        loginWindowRef.current.style.opacity = '0';
        loginWindowRef.current.style.top = '20px';
    }

    const showLogin = () => {

        if (auth.isLogged) {
            return;
        }

        setForm(form => {
            return {
                ...form,
                toggle: true,
            }
        })
        overlayRef.current.style.display = 'flex';
        setTimeout(() => {
            loginWindowRef.current.style.opacity = '1';
            loginWindowRef.current.style.top = '0';
        }, 100);
    }

    const logout = () => {
        auth.logout();
    }

    const handleForgottenPassword = e => {
        laoderGif.current.style.display = 'block';
        submitButton.current.style.display = 'none';
        e.preventDefault();

        setValidation(false);

        let loginUrl = 'reset-password';
        let data = new FormData(e.target);

        Api.post(loginUrl, data)
            .then(res => {
                laoderGif.current.style.display = 'none';
                submitButton.current.style.display = 'block';

                if (res.status === 200 && res.data.success) {
                    setForm(form => {
                        return {
                            ...form,
                            successOverlay: true,
                            sendOnEmail: res.data.via == 'email' ? true : false
                        }
                    })
                    setTimeout(() => {
                        setForm(form => {
                            return {
                                ...form,
                                successModal: true,
                            }
                        })
                    }, 50);
                } else setValidation(true);
            })
            .catch(error => {
                laoderGif.current.style.display = 'none';
                submitButton.current.style.display = 'block';
                setValidation(true);
            });
    }

    const handleSuccessOk = () => {
        setForm(form => {
            return {
                ...form,
                successModal: false,
            }
        })
        setTimeout(() => {
            setForm(form => {
                return {
                    ...form,
                    successOverlay: false,
                }
            })
        }, 100);
    }

    const handleErrorOk = () => {
        setForm(form => {
            return {
                ...form,
                errorModal: false,
            }
        })
        setTimeout(() => {
            setForm(form => {
                return {
                    ...form,
                    errorOverlay: false,
                }
            })
        }, 100);
    }

    const handleToggle = () => {

        if (form.toggle) {
            setForm(form => {
                return {
                    ...form,
                    toggle: false,
                }
            })
        } else {
            setForm(form => {
                return {
                    ...form,
                    toggle: true,
                }
            })
        }
    }

    useEffect(() => {
        if (props.openLogin) showLogin();
    }, [props.openLogin])


    const toggleMenu = toggle => {
        setForm(form => {
            return {
                ...form,
                menu: toggle,
            }
        });

        if (toggle) {
            document.querySelector('body').classList.add('toggle-menu')
            // document.querySelector('body').style.overflow = 'hidden'
            // document.querySelector('html').style.overflow = 'hidden'
        } else {
            document.querySelector('body').classList.remove('toggle-menu')
            // if (!main.activateModal) {
            //     document.querySelector('body').style.overflow = 'initial'
            //     document.querySelector('html').style.overflow = 'initial'
            // }
        }
    }

    const toggleMenuClick = () => {
        document.getElementById('menyAvPaa').click();
    }

    const responseFacebook = (response) => {
        let interval = setInterval(() => {
            setForm(form => {
                return {
                    ...form,
                    fbLoading: true,
                }
            });
        }, 100);
        if (response.id) {

            const invitationLink = window.localStorage.getItem('r');

            if (invitationLink) {
                response['link'] = invitationLink;
            }

            Api.post('fblogin', response)
                .then(res => {
                    if (res.status == 200 && res.data.success) {

                        window.localStorage.removeItem('r');

                        auth.login(res.data.data.user);
                        // props.history.push('/');
                        window.location.href = '/';

                        setForm(form => {
                            return {
                                ...form,
                                fbLoading: false,
                            }
                        });
                    }
                }).catch(err => {
                    setForm(form => {
                        return {
                            ...form,
                            fbLoading: false,
                        }
                    });
                });
        } else {
            clearInterval(interval);

            setForm(form => {
                return {
                    ...form,
                    fbLoading: false,
                }
            });
        }

        closeLogin();
    }


    const handleClickAway = () => {
        toggleMenu(false)

        document.getElementById('menyAvPaa').checked = false

    };
    const isInstructor = auth.isLogged ? 'instructor-nav' : '';

    //

    const handleCloseActivate = close => {

        setMain(prev => {
            return {
                ...prev,
                activateModal: false,
            }
        })
        setTimeout(() => {
            setMain(prev => {
                return {
                    ...prev,
                    activateOverlay: close,
                    activateModal: false,
                }
            })
        }, 100);
    }

    const handleActivationMethod = (a, m) => {
        setMain(prev => {
            return {
                ...prev,
                activateModal: a,
            }
        })
        setTimeout(() => {
            setMain(prev => {
                return {
                    ...prev,
                    methodModal: m
                }
            })
        }, 50);

    }

    const handleActivate = () => {

        setMain(prev => {
            return {
                ...prev,
                activateOverlay: true,
                showCodeModal: true
            }
        })
        setTimeout(() => {
            setMain(prev => {
                return {
                    ...prev,
                    activateModal: true
                }
            })
            setTimeout(() => {
                handleClickAway()
            }, 200);
        }, 50);
    }

    const hideCodeModal = () => {
        setTimeout(() => {
            setMain(prev => {
                return {
                    ...prev,
                    showCodeModal: false
                }
            })
        }, 100);

    }

    return (
        <>
            {/* main.activateOverlay || main.showCodeModal ?  */}
            <Activate
                blur={main.activateOverlay}
                popup={main.activateModal}
                close={handleCloseActivate}
                activationMethood={handleActivationMethod}
                open={handleActivate}
                methodModal={main.methodModal}
                hideCodeModal={hideCodeModal}
            />
            <Info
                blur={form.errorOverlay}
                popup={form.errorModal}
                acceptCallback={handleErrorOk}
                mainMessage="Вашият профил все още не е потвърден!"
                secondaryMessage="Очаквайте да се свържем с Вас, за да ви уведомим за потвърждението на профила."
            />
            <ClickAwayListener onClickAway={handleClickAway}>
                <header id="header" className={[props.headerBlackFonts ? 'black-style' : '', props.basicHeader ? 'basic' : ''].join(' ')}>
                    <div className="wrapper">
                        <input type="checkbox" id="menyAvPaa" onChange={() => toggleMenu(form.menu ? false : true)} />
                        <label id="burger" htmlFor="menyAvPaa">
                            <div></div>
                            <div></div>
                            <div></div>
                        </label>
                        <a target="_blank" href="/" className="brand">
                            {window.innerWidth > 1024 ?
                                <img src={brand} alt="brand" />
                                :
                                <img src={brandWhite} alt="brand-white" />
                            }
                            <h2>
                                Авто Обучение
                                <span>
                                    Мултимедийно интерактивно учебно помагало
                                </span>
                            </h2>
                        </a>

                        {auth.isLogged ?
                            ''
                            : <Button id="show-login" className="login-button" onClick={showLogin}>Вход</Button>
                        }

                        <nav className={form.menu ? `${isInstructor} show` : isInstructor}>
                            {!auth.isLogged ? <div className="not-logged-top hidden-desktop">
                                <a target="_blank" href="/" className="brand">
                                    <img src={brandBlack} alt="brand-white" />
                                    <h2>
                                        Авто Обучение
                                    </h2>
                                </a>
                                {/* <Button onClick={() => {
                                    handleClickAway()
                                    showLogin()
                                }}>
                                    Започни сега
                                </Button> */}
                            </div> : ''}
                            <ul className="main-menu">
                                {auth.isLogged && window.innerWidth > 1024 ?
                                    <li>
                                        Основно меню
                                    </li>
                                    :
                                    ''
                                }
                                <ul>
                                    <li className={auth.isLogged ? 'hidden-desktop' : ''}>
                                        <a target="_blank" href="https://avtoobuchenie.bg">
                                            Начало
                                        </a>
                                    </li>
                                    <li>
                                        <a target="_blank" href="https://avtoobuchenie.bg/about-students" className={window.location.pathname.indexOf('/about-students') != -1 ? 'active' : ''}>
                                            За курсисти
                                        </a>
                                    </li>
                                    <li>
                                        <a target="_blank" href="https://avtoobuchenie.bg/about-schools" className={window.location.pathname.indexOf('/about-schools') != -1 ? 'active' : ''}>
                                            За учебни центрове
                                        </a>
                                    </li>
                                    <li>
                                        <a target="_blank" href="https://avtoobuchenie.bg/recommend" className={window.location.pathname.indexOf('/recommend') != -1 ? 'active' : ''}>
                                            Препоръчваме
                                        </a>
                                    </li>
                                    <li>
                                        <a target="_blank" href="https://avtoobuchenie.bg/driving-schools" className={window.location.pathname.indexOf('/driving-schools') != -1 ? 'active' : ''}>
                                            Автошколи
                                        </a>
                                    </li>

                                    {auth.isLogged && auth.user.is_student ?
                                        <li>
                                            <a target="_blank" href="https://avtoobuchenie.bg/contacts" className={window.location.pathname.indexOf('/contacts') != -1 ? 'active' : ''}>
                                                Контакти
                                            </a>
                                        </li>
                                        :
                                        ''
                                    }
                                </ul>
                            </ul>
                            {!auth.user.is_student ?
                                <ul className="contacts">
                                    <li>
                                        <a target="_blank" href="https://avtoobuchenie.bg/contacts" className={window.location.pathname.indexOf('/contacts') != -1 ? 'active' : ''}>
                                            Контакти
                                        </a>
                                    </li>
                                </ul>
                                :
                                ''
                            }
                            <ul className={`user-menu ${auth.user.is_student ? 'is-student' : 'is-instructor'}`}>
                                {auth.isLogged ?
                                    <>
                                        <div className="divider"></div>
                                        {!auth.user.activated && auth.user.is_student ? <li className="activate">
                                            <Button onClick={handleActivate}>
                                                <img src={keysIcon} alt="Активирай" />
                                                Активирай
                                            </Button>
                                        </li> : ''}
                                        {(auth.user.is_administrator || auth.user.is_instructor) && auth.user.center.board ? <li className="irs">
                                            <Link href="/">
                                                {app.boardStatus.loading ?
                                                    <img src={loaderWhite} />
                                                    :
                                                    app.boardStatus.connected ?
                                                        <img src={checkIcon} title="Връзка с устройствата е установена успешно!" />
                                                        :
                                                        <img src={attentionIcon} title="Не беше установена връзка с устройствата." />
                                                }
                                            Табла
                                        </Link>
                                        </li> : ''}
                                        {/* <li className="menu-top-part">
                                            <a target="_blank" href="https://avtoobuchenie.bg/" className={window.location.pathname == '/' ? 'active' : ''} onClick={() => auth.refresh()}>
                                                <img src={auth.user.avatar} />
                                                <div className="right">
                                                    {auth.user.is_student ?
                                                        'Моето обучение'
                                                        :
                                                        'Моите курсисти'
                                                    }
                                                    <i>
                                                        {auth.user.name}
                                                    </i>
                                                </div>
                                            </a>
                                        </li> */}
                                    </>
                                    :
                                    ''
                                }
                                {/* {auth.isLogged && !auth.user.is_student ?
                                    <>
                                        <li className="theory">
                                            <a target="_blank" href="https://avtoobuchenie.bg/topics" className={window.location.pathname.indexOf('/topics') != -1 ? 'active' : ''}>
                                                Теория
                                            </a>
                                        </li>
                                        {auth.user.center.id != 934
                                            ?
                                            <li className="store">
                                                <a target="_blank" href="https://avtoobuchenie.bg/store" className={window.location.pathname.indexOf('/store') != -1 ? 'active' : ''}>
                                                    Магазин
                                                </a>
                                            </li>
                                            :
                                            ''
                                        }

                                    </>
                                    :
                                    ''
                                } */}
                                {/* {auth.user.configured == 1 ?
                                    <li className={`profile-menu ${auth.user.is_administrator ? 'admin-profile' : ''}`}>
                                        <a target="_blank" href="https://avtoobuchenie.bg/profile-edit" className={window.location.pathname.indexOf('/profile-edit') != -1 || window.location.pathname.indexOf('/center-profile') != -1 ? 'active current-link' : 'current-link'}>
                                            {window.innerWidth < 1024 ? 'Моят профил' : 'Профил'}
                                        </a>
                                        {auth.user.is_administrator ?
                                            <ul>
                                                <li>
                                                    <a target="_blank" href="https://avtoobuchenie.bg/profile-edit">
                                                        Личен профил
                                                    </a>
                                                </li>
                                                <li className="center-profile">
                                                    <a target="_blank" href="https://avtoobuchenie.bg/center-profile">
                                                        Профил на учебен център
                                                    </a>
                                                </li>

                                            </ul>
                                            :
                                            ''
                                        }
                                    </li>
                                    :
                                    ''
                                } */}
                                {auth.isLogged && auth.user.is_student && auth.user.configured && window.innerWidth <= 1024 ? <li className="messages-menu" onClick={() => {
                                    handleClickAway()
                                    document.querySelector('.notifications-nav').setAttribute('data-clicked', 1)
                                    document.querySelector('.notifications-nav').click()
                                    setTimeout(() => {
                                        document.querySelector('.notifications-nav').setAttribute('data-clicked', 0)
                                    }, 1000)
                                }}>
                                    Съобщения
                                </li> : ''}
                                {!auth.isLogged
                                    ? ''
                                    :
                                    <>
                                        <li className="logout hidden-mobile" onClick={logout}>
                                            <img src={logoutIcon} />
                                            Изход
                                        </li>
                                    </>
                                }
                            </ul>
                            {auth.isLogged ?
                                <ul className="single-logout hidden-desktop">
                                    <li className="logout" onClick={logout}>
                                        <img src={logoutIcon} />
                                        Изход
                                    </li>
                                </ul> : ''}
                            {!auth.isLogged ? <ul className="not-logged-bottom hidden-desktop">
                                <li>
                                    Последвайте ни
                                </li>
                                <li className="follow-us">
                                    <a target="_blank" href="https://www.facebook.com/avtoobuchenie" target="_blank">
                                        <img src={fbFilledIcon} /> / AvtoObuchenie
                                    </a>
                                </li>
                            </ul> : ''}
                        </nav>
                        {auth.isLogged && auth.user.is_student && auth.user.configured ?
                            <ul>
                                <Notifications />
                            </ul> : ''}
                    </div>
                </header>
            </ClickAwayListener>
            <Success
                blur={form.successOverlay}
                popup={form.successModal}
                mainMessage="Новата Ви парола беше изпратена успешно!"
                secondaryMessage={form.sendOnEmail ? 'Можете да откриете Вашата нова парола на посочената от Вас Е-поща.' : 'Ще получите новата парола като SMS на посочения от Вас тел. номер.'}
                acceptCallback={handleSuccessOk}
            />
            <Loading
                show={form.fbLoading}
                color="#fb9c32"
                showSpinner={false}
            />
        </>
    );
}

export default Header;
